module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f52abe3937d07c29f2374f5d33487b14.png";